import { FEATURES } from "const/feature/const";
import * as paths from "./const";
import * as pages from "pages";

export const routes = {
  common: [
    {
      path: paths.ROUTE_ROOT,
      component: pages.MainPageComponent,
    },
    {
      path: paths.ROUTE_LOGIN,
      component: pages.LoginPageComponent,
    },
    {
      path: paths.ROUTE_AUTH_CALLBACK,
      component: pages.AuthCallbackPageComponent,
    },
    {
      path: paths.ROUTE_LIBRARY,
      component: pages.LibraryPageComponent,
    },
    {
      path: paths.ROUTE_LIBRARY_DATASETS,
      component: FEATURES.S_CORE_MODE
        ? pages.LibraryDatasetOnlyPageComponent
        : pages.LibraryDatasetsPageComponent,
    },
    {
      path: paths.ROUTE_LIBRARY_DATASOURCES,
      component: pages.LibraryDatasourcesPageComponent,
    },

    {
      path: paths.ROUTE_LIBRARY_LOGS,
      component: pages.LibraryLogsPageComponent,
    },

    {
      path: paths.ROUTE_MART_ANSWERSET,
      component: FEATURES.S_CORE_MODE
        ? pages.LibraryAnswersetOnlyPageComponent
        : pages.Error404PageComponent,
    },
    {
      path: paths.ROUTE_MART_LOGS,
      component: FEATURES.S_CORE_MODE
        ? pages.LibraryLogsPageComponent
        : pages.Error404PageComponent,
    },

    {
      path: paths.ROUTE_MANUAL,
      component: pages.ManualPageComponent,
    },

    {
      path: paths.ROUTE_PROJECT,
      component: pages.ProjectPageComponent,
    },
    {
      path: paths.ROUTE_PROJECT_LIST,
      component: pages.ProjectListComponent,
    },
    {
      path: paths.ROUTE_PROJECT_DATA,
      component: pages.ProjectDataComponent,
    },
    {
      path: paths.ROUTE_PROJECT_JUPYTER,
      component: FEATURES.S_CORE_MODE
        ? pages.ExternalJupyterPageComponent
        : pages.Error404PageComponent,
    },

    {
      path: paths.ROUTE_FLOW,
      component: pages.FlowPageComponent,
    },
    {
      path: paths.ROUTE_FLOW_FLOWS,
      component: pages.FlowFlowsComponent,
    },
    {
      path: paths.ROUTE_FLOW_GROUPS,
      component: pages.FlowGroupsComponent,
    },
    {
      path: paths.ROUTE_FLOW_LOGS,
      component: pages.FlowLogsComponent,
    },

    {
      path: paths.ROUTE_REPORT,
      component: pages.ReportPageComponent,
    },
    {
      path: paths.ROUTE_REPORT_LIST,
      component: pages.ReportListComponent,
    },
    {
      path: paths.ROUTE_REPORT_DATA,
      component: pages.ReportDataComponent,
    },

    {
      path: paths.ROUTE_ADMIN,
      component: pages.AdminPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_USERS,
      component: pages.AdminUsersPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_GROUPS,
      component: pages.AdminGroupsPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_ROLES,
      component: pages.AdminRolesPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_CONNECTORS,
      component: pages.AdminConnectorsPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_DOMAINS,
      component: pages.AdminDomainsPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_USER_LOGS,
      component: pages.AdminUserLogsPageComponent,
    },
    {
      path: paths.ROUTE_ADMIN_MONITORING,
      component: pages.AdminLogsPageComponent,
    },

    {
      path: paths.ROUTE_EXTERNAL,
      component: pages.ExternalPageComponent,
    },
    {
      path: paths.ROUTE_EXTERNAL_JUPYTER,
      component: pages.ExternalJupyterPageComponent,
    },

    {
      path: "*",
      component: pages.Error404PageComponent,
    },
  ],
};
